"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldTypes = void 0;
const constants_1 = require("../constants");
const rows_1 = require("../fields/rows");
exports.fieldTypes = {
    [constants_1.FIELD_TYPE_NAMES.STRING]: rows_1.TextInputRow,
    [constants_1.FIELD_TYPE_NAMES.SELECT]: rows_1.SelectInputRow,
    [constants_1.FIELD_TYPE_NAMES.SIMPLE_SELECT]: rows_1.SimpleSelectInputRow,
    [constants_1.FIELD_TYPE_NAMES.CHECKBOX]: rows_1.CheckboxInputRow,
    [constants_1.FIELD_TYPE_NAMES.RADIO]: rows_1.RadioInputRow,
    [constants_1.FIELD_TYPE_NAMES.TEXTAREA]: rows_1.TextareaInputRow,
    [constants_1.FIELD_TYPE_NAMES.NAME]: rows_1.NameInputRow,
    [constants_1.FIELD_TYPE_NAMES.ARRAY]: rows_1.ArrayInputRow,
    [constants_1.FIELD_TYPE_NAMES.INLINE]: rows_1.InlineInputRow,
    [constants_1.FIELD_TYPE_NAMES.PHONE]: rows_1.PhoneInputRow,
    [constants_1.FIELD_TYPE_NAMES.DOB]: rows_1.DOBInputRow,
    [constants_1.FIELD_TYPE_NAMES.EMAIL]: rows_1.EmailInputRow,
    [constants_1.FIELD_TYPE_NAMES.ADDRESS]: rows_1.AddressInputRow,
    [constants_1.FIELD_TYPE_NAMES.CHECKBOX]: rows_1.CheckboxInputRow,
    [constants_1.FIELD_TYPE_NAMES.MULTI_SELECT]: rows_1.MultiSelectInputRow,
    [constants_1.FIELD_TYPE_NAMES.SSN]: rows_1.SSNInputRow,
    [constants_1.FIELD_TYPE_NAMES.PARTIAL_SSN]: rows_1.SSNInputRow,
    [constants_1.FIELD_TYPE_NAMES.DATE]: rows_1.DateInputRow,
    [constants_1.FIELD_TYPE_NAMES.TIME]: rows_1.TimeInputRow,
    [constants_1.FIELD_TYPE_NAMES.TYPEAHEAD]: rows_1.TypeaheadInputRow,
    [constants_1.FIELD_TYPE_NAMES.NPI]: rows_1.NPIInputRow,
    [constants_1.FIELD_TYPE_NAMES.HIDDEN]: rows_1.HiddenInputRow,
    [constants_1.FIELD_TYPE_NAMES.FILE]: rows_1.FileInputRow,
    [constants_1.FIELD_TYPE_NAMES.AGE_GROUPS_SEEN]: rows_1.AgeGroupsSeen
};
//# sourceMappingURL=fieldTypes.js.map